import React from 'react';
import Icon from '../../../components/AppIcon';

const OurStorySection = () => {
  return (
    <section className="py-20 relative text-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="flex items-center space-x-3 mb-8">
          <div className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-lg backdrop-blur-sm border border-white/20">
            <Icon name="BookOpen" size={20} color="white" />
          </div>
          <h2 className="text-4xl font-bold text-white">Our story</h2>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-10 enterprise-shadow border border-white/20">
          <p className="text-xl text-white/90 leading-relaxed">
            Mirakalous was founded to close the gap between flashy AI demos and dependable systems that ship. After years delivering ML/GenAI in healthcare, finance, retail, and industrial settings, we codified a playbook: start with the outcome, design for safety, measure relentlessly, and meet customers where their data lives (on‑prem or cloud). The projects above—from digital kidneys to code modernization—reflect that philosophy.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurStorySection;


